import React from "react";
import "@/components/user/MyBids/Editcif/editcif/editcif.css";

function ProperyInformation({ cifData }) {
  console.log("property detail information", cifData);
  const { propertyDetails } = cifData?.data || {};
  const { address, commonAttributes, imageDetails, propertyId } =
    propertyDetails || {};

  return (
    <div className="mb-3">
      <div className="row">
        <div className="col-md-12">
          <div className="custom-card">
            <div className="bg"></div>
            <div className="blob"></div>
            <div className="card-content">
              <div className="g-0 row">
                <div className="col-md-2">
                  <div className="image-container">
                    <img
                      src={
                        imageDetails?.[0]?.thumbnailUrl ||
                        "/assets/images/imageOnTheWay.webp"
                      }
                      alt={"Property_Image"}
                      className="rounded"
                      style={{
                        width: "200px", // Set a fixed width
                        height: "150px", // Set a fixed height
                        objectFit: "cover", // This ensures the image covers the area without distortion
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-10 pl30 pt5">
                  <div className="property-details">
                    <p className="infoTxtStatic">
                      The information contained within this document will be
                      used to complete the contract documentation for the
                      following property:
                      <br /> {propertyId} <br />
                      {address?.streetName}, {address?.streetNumber},{" "}
                      {address?.city} <br /> {address?.state} {address?.zip}
                    </p>
                  </div>
                </div>
                <div className="col-md-3">{/* <PropertyDetailTimer /> */}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProperyInformation;
